export default "__VITE_ASSET__1908b704__"